import ELearningResults from "./ELearningResults";

export default ELearningResults;